import {
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { ReactNode } from 'react';
import { useSelection } from '../context/SelectionContext';
import { Office } from '../../models/office';
import { Collect } from '../../models/collect';

interface CollectByOfficeFormProps {
  offices: Office[];
  collectsOffice: Collect[];
  children?: ReactNode;
}

const CollectByOfficeForm: React.FC<CollectByOfficeFormProps> = ({
  offices,
  collectsOffice,
  children,
}) => {
  const {
    office_id,
    setOffice_id,
    collect_id,
    setCollect_id,
  } = useSelection();

  const handleOfficeChange = (event: SelectChangeEvent<string>) => {
    setOffice_id(event.target.value);
  };

  const handleCollectChange = (event: SelectChangeEvent<string>) => {
    setCollect_id(event.target.value);
  };

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <CardContent>
         <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="office-select-label" shrink>Seleccionar Oficina</InputLabel>
              <Select
                labelId="office-select-label"
                id="office-select"
                size="small" 
                value={office_id}
                onChange={handleOfficeChange}
                label="Seleccionar Oficina"
                required
              >
                {offices.map((office) => (
                  <MenuItem key={office.id} value={String(office.id)}>
                    {office.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="collect-select-label" shrink>Seleccionar Cobro</InputLabel>
              <Select
                labelId="collect-select-label"
                id="collect-select"
                size="small" 
                value={collect_id}
                onChange={handleCollectChange}
                label="Seleccionar Cobro"
                required
              >
                {collectsOffice.map((collect) => (
                  <MenuItem key={collect.id} value={String(collect.id)}>
                    {collect.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {children}
        </Grid>
      </CardContent>
    </form>
  );
};

export default CollectByOfficeForm;
